export default {
  setTiers(state, payload) {
    return (state.tiers = payload);
  },
};
